import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";

import { fetchDashboardJobs } from "../store/jobThunk";
import type { JobFilters } from "../types/job";

export const useDashboardJobs = (
  initialFilters: JobFilters = {}
) => {
  const dispatch = useDispatch<any>();

  const {
    jobs,
    loading,
    error,
    pagination,
  } = useSelector(
    (state: any) => state.jobs
  );

  useEffect(() => {
    dispatch(
      fetchDashboardJobs(initialFilters)
    );
  }, [
    dispatch,
    initialFilters.search,
    initialFilters.page,
    initialFilters.limit,
    initialFilters.isActive,
    initialFilters.priority,
    initialFilters.status,
    initialFilters.department,
    initialFilters.employmentType,
    initialFilters.workplaceType,
  ]);

  const refreshDashboardJobs = () => {
    dispatch(
      fetchDashboardJobs(initialFilters)
    );
  };

  return {
    jobs,
    loading,
    error,
    pagination,
    refreshDashboardJobs,
  };
};